import { IconButton } from '@mui/material';
import { useCopyText } from './useCopyText';
import './style.scss';

interface CopyIconProps {
  text: string;
}

export const CopyIcon = ({ text }: CopyIconProps) => {
  const { copy, Icon } = useCopyText(text);

  return (
    <IconButton onClick={copy} className="copy-button">
      <Icon className={`copy-button-icon`} />
    </IconButton>
  );
};
